module.exports = __webpack_public_path__ + "img/Mo Brooks.5ef8722a.jpg";